class DestinationService {

    GetContent() {
        let response = window.__pt.destinationdata;
       

        if (response) {
            return response;
        }

        return {
            countries: [],
            destination: {},
            similarDestination: [],
            dispatch: {},
            message: null,
            status: 404
        }
    }
}

export const DestinationServices = new DestinationService();